export const NO_LIMIT_REWARD_TEXT = "No Limits";

export const getRemainingPoints = (reward) => {
    const alreadyClaimedRewards = reward?.redeemedCountForSeason;
    const alreadyClaimedRewardsByUser = reward?.redeemDetails?.length;

    if(reward?.limitPerUser) {
        return (reward?.isLimitedQuantity ? Math.min((reward?.limitPerSeason - alreadyClaimedRewards), (reward?.limitPerUser - alreadyClaimedRewardsByUser)) : NO_LIMIT_REWARD_TEXT);
    }else {
        return (reward?.isLimitedQuantity ? (reward?.limitPerSeason - alreadyClaimedRewards) : NO_LIMIT_REWARD_TEXT);
    }
}

export const getRemainingPointsForUser = (reward) => {
    const alreadyClaimedRewardsByUser = reward?.redeemDetails.length;

    return (reward?.limitPerUser ? reward?.limitPerUser - alreadyClaimedRewardsByUser : NO_LIMIT_REWARD_TEXT);
}